import { handleActions } from 'redux-actions';
import { createSelector } from 'reselect';
import { WizardActions } from '../actions/WizardActions';

const initialState = {
  page: 0,
  totalPages: 0,
};

export const Wizard = handleActions(
  {
    [WizardActions.GO_TO_NEXT_PAGE]: (state) => {
      const page = Math.min(state.page + 1, state.totalPages - 1);
      return { ...state, page };
    },
    [WizardActions.GO_TO_PREV_PAGE]: (state) => {
      const page = Math.max(state.page - 1, 0);
      return { ...state, page };
    },
    [WizardActions.GO_TO_PAGE]: (state, actions) => {
      const { page: newPage } = actions.payload;
      if (newPage !== state.page) {
        return { ...state, page: actions.payload.page };
      }
      return { ...state };
    },
    [WizardActions.SET_TOTAL_PAGES]: (state, actions) => {
      return { ...state, page: 0, totalPages: actions.payload.total };
    },
  },
  initialState
);

const getWizard = (state) => state.Wizard;

export const getCurrentPage = createSelector(getWizard, (state) => {
  return state.page;
});
